import type { I18nLocale } from '@ardoq/i18n';
import accessControlPackageDe from '@ardoq/access-control/translations/de.json';
import accessControlPackageFr from '@ardoq/access-control/translations/fr.json';
import aiTranslationsDe from '@ardoq/ai/translations/de.json';
import aiTranslationsFr from '@ardoq/ai/translations/fr.json';
import dateRangeTranslationsDe from '@ardoq/date-range/translations/de.json';
import dateRangeTranslationsFr from '@ardoq/date-range/translations/fr.json';
import dateTimeTranslationsDe from '@ardoq/date-time/translations/de.json';
import dateTimeTranslationsFr from '@ardoq/date-time/translations/fr.json';
import dateTimePickerTranslationsDe from '@ardoq/date-time-picker/translations/de.json';
import dateTimePickerTranslationsFr from '@ardoq/date-time-picker/translations/fr.json';
import buttonTranslationsDe from '@ardoq/button/translations/de.json';
import buttonTranslationsFr from '@ardoq/button/translations/fr.json';
import cardTranslationsDe from '@ardoq/card/translations/de.json';
import cardTranslationsFr from '@ardoq/card/translations/fr.json';
import commonHelpersTranslationsDe from '@ardoq/common-helpers/translations/de.json';
import commonHelpersTranslationsFr from '@ardoq/common-helpers/translations/fr.json';
import componentHierarchiesPackageDe from '@ardoq/component-hierarchies/translations/de.json';
import componentHierarchiesPackageFr from '@ardoq/component-hierarchies/translations/fr.json';
import componentOverviewPackageDe from '@ardoq/component-overview/translations/de.json';
import componentOverviewPackageFr from '@ardoq/component-overview/translations/fr.json';
import dashboardPackageDe from '@ardoq/dashboard/translations/de.json';
import dashboardPackageFr from '@ardoq/dashboard/translations/fr.json';
import drawerTranslationsDe from '@ardoq/drawer/translations/de.json';
import drawerTranslationsFr from '@ardoq/drawer/translations/fr.json';
import dropdownMenuTranslationsDe from '@ardoq/dropdown-menu/translations/de.json';
import dropdownMenuTranslationsFr from '@ardoq/dropdown-menu/translations/fr.json';
import graphTranslationsDe from '@ardoq/graph/translations/de.json';
import graphTranslationsFr from '@ardoq/graph/translations/fr.json';
import graphViewTranslationsDe from '@ardoq/graph-view/translations/de.json';
import graphViewTranslationsFr from '@ardoq/graph-view/translations/fr.json';
import inAppNotificationsPackageDe from '@ardoq/in-app-notifications/translations/de.json';
import inAppNotificationsPackageFr from '@ardoq/in-app-notifications/translations/fr.json';
import integrationsPackageDe from '@ardoq/integrations/translations/de.json';
import integrationsPackageFr from '@ardoq/integrations/translations/fr.json';
import steppersTranslationsDe from '@ardoq/steppers/translations/de.json';
import steppersTranslationsFr from '@ardoq/steppers/translations/fr.json';
import pageLayoutTranslationsDe from '@ardoq/page-layout/translations/de.json';
import pageLayoutTranslationsFr from '@ardoq/page-layout/translations/fr.json';
import productToursTranslationsDe from '@ardoq/product-tours/translations/de.json';
import productToursTranslationsFr from '@ardoq/product-tours/translations/fr.json';
import perspectivesTranslationsDe from '@ardoq/perspectives/translations/de.json';
import perspectivesTranslationsFr from '@ardoq/perspectives/translations/fr.json';
import perspectivesSidebarTranslationsDe from '@ardoq/perspectives-sidebar/translations/de.json';
import perspectivesSidebarTranslationsFr from '@ardoq/perspectives-sidebar/translations/fr.json';
import queryBuilderTranslationsDe from '@ardoq/query-builder/translations/de.json';
import queryBuilderTranslationsFr from '@ardoq/query-builder/translations/fr.json';
import renderersTranslationsDe from '@ardoq/renderers/translations/de.json';
import renderersTranslationsFr from '@ardoq/renderers/translations/fr.json';
import richTextEditorTranslationsDe from '@ardoq/rich-text-editor/translations/de.json';
import richTextEditorTranslationsFr from '@ardoq/rich-text-editor/translations/fr.json';
import selectTranslationsDe from '@ardoq/select/translations/de.json';
import selectTranslationsFr from '@ardoq/select/translations/fr.json';
import formsTranslationsDe from '@ardoq/forms/translations/de.json';
import formsTranslationsFr from '@ardoq/forms/translations/fr.json';
import impersonationTranslationsDe from '@ardoq/impersonation/translations/de.json';
import impersonationTranslationsFr from '@ardoq/impersonation/translations/fr.json';
import inventoryTranslationsDe from '@ardoq/inventory/translations/de.json';
import inventoryTranslationsFr from '@ardoq/inventory/translations/fr.json';
import provenanceTranslationsDe from '@ardoq/provenance/translations/de.json';
import provenanceTranslationsFr from '@ardoq/provenance/translations/fr.json';
import loginPackageDe from '@ardoq/login/translations/de.json';
import loginPackageFr from '@ardoq/login/translations/fr.json';
import snowflakesTranslationsDe from '@ardoq/snowflakes/translations/de.json';
import snowflakesTranslationsFr from '@ardoq/snowflakes/translations/fr.json';
import settingsBarTranslationsDe from '@ardoq/settings-bar/translations/de.json';
import settingsBarTranslationsFr from '@ardoq/settings-bar/translations/fr.json';
import statusUiTranslationsDe from '@ardoq/status-ui/translations/de.json';
import statusUiTranslationsFr from '@ardoq/status-ui/translations/fr.json';
import surveysUiTranslationsDe from '@ardoq/surveys-ui/translations/de.json';
import surveysUiTranslationsFr from '@ardoq/surveys-ui/translations/fr.json';
import timeline2024TranslationsDe from '@ardoq/timeline2024/translations/de.json';
import timeline2024TranslationsFr from '@ardoq/timeline2024/translations/fr.json';
import viewLegendDe from '@ardoq/view-legend/translations/de.json';
import viewLegendFr from '@ardoq/view-legend/translations/fr.json';
import commonDe from 'locales/de/common.json';
import commonFr from 'locales/fr/common.json';
import colorPickerDe from 'locales/de/colorPicker.json';
import colorPickerFr from 'locales/fr/colorPicker.json';
import landingPageDe from 'locales/de/landingPage.json';
import landingPageFr from 'locales/fr/landingPage.json';
import manageResourcePermissionsDe from 'locales/de/manageResourcePermissions.json';
import manageResourcePermissionsFr from 'locales/fr/manageResourcePermissions.json';
import metamodelVisualizationDe from 'locales/de/metamodelVisualization.json';
import metamodelVisualizationFr from 'locales/fr/metamodelVisualization.json';
import paginationDe from 'locales/de/pagination.json';
import paginationFr from 'locales/fr/pagination.json';
import jsonIntegrationDe from 'integrations/json/translations/de.json';
import jsonIntegrationFr from 'integrations/json/translations/fr.json';
import referenceDataDe from 'integrations/reference-data/translations/de.json';
import referenceDataFr from 'integrations/reference-data/translations/fr.json';
import flexibleBlockDiagramDe from 'tabview/flexibleBlockDiagram/translations/de.json';
import flexibleBlockDiagramFr from 'tabview/flexibleBlockDiagram/translations/fr.json';
import relationsD3ViewDe from 'tabview/relationsD3View/translations/de.json';
import relationsD3ViewFr from 'tabview/relationsD3View/translations/fr.json';
import reportBuilderDe from '@ardoq/report-builder/translations/de.json';
import reportBuilderFr from '@ardoq/report-builder/translations/fr.json';
import reportReaderDe from 'locales/de/reportReader.json';
import reportReaderFr from 'locales/fr/reportReader.json';
import simpleBlockDiagramDe from 'locales/de/simpleBlockDiagram.json';
import simpleBlockDiagramFr from 'locales/fr/simpleBlockDiagram.json';
import dropzoneDe from 'locales/de/dropzone.json';
import dropzoneFr from 'locales/fr/dropzone.json';
import modalDe from 'locales/de/modal.json';
import modalFr from 'locales/fr/modal.json';
import notFoundDe from 'locales/de/notFound.json';
import notFoundFr from 'locales/fr/notFound.json';
import inAppNotificationsDe from 'locales/de/inAppNotifications.json';
import inAppNotificationsFr from 'locales/fr/inAppNotifications.json';
import imagePreviewDe from 'locales/de/imagePreview.json';
import imagePreviewFr from 'locales/fr/imagePreview.json';
import apiErrorsDe from 'locales/de/apiErrors.json';
import apiErrorsFr from 'locales/fr/apiErrors.json';
import errorInfoBoxDe from 'locales/de/errorInfoBox.json';
import errorInfoBoxFr from 'locales/fr/errorInfoBox.json';
import metamodelConstraintsDe from 'locales/de/metamodelConstraints.json';
import metamodelConstraintsFr from 'locales/fr/metamodelConstraints.json';
import metamodelEditorDe from 'locales/de/metamodelEditor.json';
import metamodelEditorFr from 'locales/fr/metamodelEditor.json';
import tableDe from 'locales/de/table.json';
import tableFr from 'locales/fr/table.json';
import tagsDe from 'locales/de/tags.json';
import tagsFr from 'locales/fr/tags.json';
import timelineDe from 'locales/de/timeline.json';
import timelineFr from 'locales/fr/timeline.json';
import navigationTopBarDe from 'navigationTopBar/translations/de.json';
import navigationTopBarFr from 'navigationTopBar/translations/fr.json';
import bubbleChartDe from 'locales/de/bubbleChart.json';
import bubbleChartFr from 'locales/fr/bubbleChart.json';
import bundlesDe from 'admin/bundles/translations/de.json';
import bundlesFr from 'admin/bundles/translations/fr.json';
import profileDe from 'admin/user/ProfileView/translations/de.json';
import profileFr from 'admin/user/ProfileView/translations/fr.json';
import accountDe from 'admin/user/translations/de.json';
import accountFr from 'admin/user/translations/fr.json';
import orgSettingsDe from 'admin/orgSettings/translations/de.json';
import orgSettingsFr from 'admin/orgSettings/translations/fr.json';
import brandingSettingsDe from 'admin/brandingSettings/translations/de.json';
import brandingSettingsFr from 'admin/brandingSettings/translations/fr.json';
import featureSettingsDe from 'admin/featureSettings/translations/de.json';
import featureSettingsFr from 'admin/featureSettings/translations/fr.json';
import homeSettingsDe from 'admin/homeSettings/translations/de.json';
import homeSettingsFr from 'admin/homeSettings/translations/fr.json';
import aiSettingsDe from 'admin/aiSettings/translations/de.json';
import aiSettingsFr from 'admin/aiSettings/translations/fr.json';
import ardoqCatalogDe from 'admin/ardoqCatalog/translations/de.json';
import ardoqCatalogFr from 'admin/ardoqCatalog/translations/fr.json';
import catalogFeedbackDe from 'ardoqCatalog/feedback/translations/de.json';
import catalogFeedbackFr from 'ardoqCatalog/feedback/translations/fr.json';
import catalogAttributionDe from 'ardoqCatalog/attribution/translations/de.json';
import catalogAttributionFr from 'ardoqCatalog/attribution/translations/fr.json';
import catalogDetailsDe from 'ardoqCatalog/details/translations/de.json';
import catalogDetailsFr from 'ardoqCatalog/details/translations/fr.json';
import catalogLinkDe from 'ardoqCatalog/link/translations/de.json';
import catalogLinkFr from 'ardoqCatalog/link/translations/fr.json';
import catalogSearchDe from 'ardoqCatalog/search/translations/de.json';
import catalogSearchFr from 'ardoqCatalog/search/translations/fr.json';
import catalogPendingLinksDe from 'admin/ardoqCatalog/pendingLinks/translations/de.json';
import catalogPendingLinksFr from 'admin/ardoqCatalog/pendingLinks/translations/fr.json';
import transformationsSettingsDe from 'admin/transformationsSettings/translations/de.json';
import transformationsSettingsFr from 'admin/transformationsSettings/translations/fr.json';
import catalogFieldMappingDe from 'admin/ardoqCatalog/fieldMapping/translations/de.json';
import catalogFieldMappingFr from 'admin/ardoqCatalog/fieldMapping/translations/fr.json';
import graphFiltersDe from 'admin/graphFilters/translations/de.json';
import graphFiltersFr from 'admin/graphFilters/translations/fr.json';
import manageOrganizationDe from 'admin/manageOrganization/translations/de.json';
import manageOrganizationFr from 'admin/manageOrganization/translations/fr.json';
import subscriptionDe from 'admin/subscription/translations/de.json';
import subscriptionFr from 'admin/subscription/translations/fr.json';
import timeTravelDe from 'admin/timeTravel/translations/de.json';
import timeTravelFr from 'admin/timeTravel/translations/fr.json';
import workspaceOverviewDe from 'admin/workspaceOverview/translations/de.json';
import workspaceOverviewFr from 'admin/workspaceOverview/translations/fr.json';
import systemOverviewDe from 'admin/systemOverview/translations/de.json';
import systemOverviewFr from 'admin/systemOverview/translations/fr.json';
import migrationChecklistDe from 'admin/migrationChecklist/translations/de.json';
import migrationChecklistFr from 'admin/migrationChecklist/translations/fr.json';
import cardGridViewerDe from 'components/CardGridViewer/translations/de.json';
import cardGridViewerFr from 'components/CardGridViewer/translations/fr.json';
import dataLimitDe from 'components/DataLimit/translations/de.json';
import dataLimitFr from 'components/DataLimit/translations/fr.json';
import defaultFieldsDe from 'streams/fields/translations/de.json';
import defaultFieldsFr from 'streams/fields/translations/fr.json';
import deleteAssetModalDe from 'components/DeleteAssetModal/translations/de.json';
import deleteAssetModalFr from 'components/DeleteAssetModal/translations/fr.json';
import confirmDeletionDe from 'components/Dialogs/confirmDeletion/translations/de.json';
import confirmDeletionFr from 'components/Dialogs/confirmDeletion/translations/fr.json';
import diffMergeDe from 'components/DiffMergeTable/translations/de.json';
import diffMergeFr from 'components/DiffMergeTable/translations/fr.json';
import emptyWorkspaceDe from 'components/EmptyWorkspace/translations/de.json';
import emptyWorkspaceFr from 'components/EmptyWorkspace/translations/fr.json';
import folderSelectDialogDe from 'components/FolderSelectDialog/translations/de.json';
import locationSelectDe from 'components/LocationSelect/translations/de.json';
import folderSelectDialogFr from 'components/FolderSelectDialog/translations/fr.json';
import locationSelectFr from 'components/LocationSelect/translations/fr.json';
import entityBrowserDe from 'components/EntityBrowser/translations/de.json';
import entityBrowserFr from 'components/EntityBrowser/translations/fr.json';
import entityGroupDe from 'admin/entityGroup/translations/de.json';
import entityGroupFr from 'admin/entityGroup/translations/fr.json';
import entityMergeDe from 'components/EntityMerge/translations/de.json';
import entityMergeFr from 'components/EntityMerge/translations/fr.json';
import surveyAdminDe from 'surveyAdmin/translations/de.json';
import surveyAdminFr from 'surveyAdmin/translations/fr.json';
import dashboardDe from 'dashboard/translations/de.json';
import dashboardFr from 'dashboard/translations/fr.json';
import discoverLandingPageDe from 'discoverLandingPage/translations/de.json';
import discoverLandingPageFr from 'discoverLandingPage/translations/fr.json';
import discoverSettingsDe from 'admin/discoverSettings/translations/de.json';
import discoverSettingsFr from 'admin/discoverSettings/translations/fr.json';
import serviceAccountsDe from 'admin/accessControl/pages/serviceAccounts/translations/de.json';
import serviceAccountsFr from 'admin/accessControl/pages/serviceAccounts/translations/fr.json';
import ipAllowListingDe from 'admin/accessControl/pages/IPAllowListing/translations/de.json';
import ipAllowListingFr from 'admin/accessControl/pages/IPAllowListing/translations/fr.json';
import orgMembersDe from 'admin/accessControl/pages/orgMembers/translations/de.json';
import orgMembersFr from 'admin/accessControl/pages/orgMembers/translations/fr.json';
import privilegesDe from 'privileges/translations/de.json';
import privilegesFr from 'privileges/translations/fr.json';
import permissionGroupsDe from 'admin/accessControl/pages/PermissionGroups/translations/de.json';
import permissionGroupsFr from 'admin/accessControl/pages/PermissionGroups/translations/fr.json';
import permissionsPanelDe from 'permissions-panel/translations/de.json';
import permissionsPanelFr from 'permissions-panel/translations/fr.json';
import ssoAttributeMappingDe from 'admin/accessControl/pages/ssoAttributeMapping/translations/de.json';
import ssoAttributeMappingFr from 'admin/accessControl/pages/ssoAttributeMapping/translations/fr.json';
import assetsOverviewDe from 'admin/accessControl/pages/AssetsOverview/translations/de.json';
import assetsOverviewFr from 'admin/accessControl/pages/AssetsOverview/translations/fr.json';
import loginSettingsDe from 'admin/accessControl/pages/loginSettings/translations/de.json';
import loginSettingsFr from 'admin/accessControl/pages/loginSettings/translations/fr.json';
import userProvisioningSettingsDe from 'admin/accessControl/pages/userProvisioningSettings/translations/de.json';
import userProvisioningSettingsFr from 'admin/accessControl/pages/userProvisioningSettings/translations/fr.json';
import manageUserRolesDe from 'admin/accessControl/pages/ManageUserRoles/translations/de.json';
import manageUserRolesFr from 'admin/accessControl/pages/ManageUserRoles/translations/fr.json';
import helpAndSupportDe from 'admin/accessControl/pages/HelpAndSupport/translations/de.json';
import helpAndSupportFr from 'admin/accessControl/pages/HelpAndSupport/translations/fr.json';
import confidentialFieldsDe from 'admin/accessControl/pages/ConfidentialFields/translations/de.json';
import confidentialFieldsFr from 'admin/accessControl/pages/ConfidentialFields/translations/fr.json';
import useCaseDe from 'admin/useCase/translations/de.json';
import useCaseFr from 'admin/useCase/translations/fr.json';
import useCasesDe from 'useCases/translations/de.json';
import useCasesFr from 'useCases/translations/fr.json';
import auditLogDe from 'auditLog/translations/de.json';
import auditLogFr from 'auditLog/translations/fr.json';
import presentationAdminDe from 'presentation/translations/de.json';
import presentationAdminFr from 'presentation/translations/fr.json';
import presentationsBrowserDe from 'components/presentationsBrowserDialog/translations/de.json';
import presentationsBrowserFr from 'components/presentationsBrowserDialog/translations/fr.json';
import presentationEditorDe from 'presentationEditor/translations/de.json';
import presentationEditorFr from 'presentationEditor/translations/fr.json';
import presentationSidebarDe from 'components/presentationSidebar/translations/de.json';
import presentationSidebarFr from 'components/presentationSidebar/translations/fr.json';
import propertiesEditorDe from 'appModelStateEdit/propertiesEditor/translations/de.json';
import propertiesEditorFr from 'appModelStateEdit/propertiesEditor/translations/fr.json';
import assetsBrowserDe from 'components/AssetsBrowser2024/translations/de.json';
import assetsBrowserFr from 'components/AssetsBrowser2024/translations/fr.json';
import metamodelDe from 'metamodel/translations/de.json';
import metamodelFr from 'metamodel/translations/fr.json';
import organizationMetamodelDe from 'organizationMetamodel/translations/de.json';
import organizationMetamodelFr from 'organizationMetamodel/translations/fr.json';
import broadcastsDe from 'broadcasts/translations/de.json';
import broadcastsFr from 'broadcasts/translations/fr.json';
import globalLoginDe from 'newAuth/GlobalLoginForm/translations/de.json';
import globalLoginFr from 'newAuth/GlobalLoginForm/translations/fr.json';
import gridEditorDe from 'gridEditor/translations/de.json';
import gridEditorFr from 'gridEditor/translations/fr.json';
import searchModalDe from 'searchModal/translations/de.json';
import searchModalFr from 'searchModal/translations/fr.json';
import tasksDe from 'tasks/translations/de.json';
import tasksFr from 'tasks/translations/fr.json';
import contextBarDe from 'contextBar/translations/de.json';
import contextBarFr from 'contextBar/translations/fr.json';
import accessControlContainerDe from 'admin/accessControl/AccessControlPageContainer/translations/de.json';
import accessControlContainerFr from 'admin/accessControl/AccessControlPageContainer/translations/fr.json';
import rolesDe from 'admin/accessControl/roles/translations/de.json';
import rolesFr from 'admin/accessControl/roles/translations/fr.json';
import componentHierarchiesDe from 'componentHierarchies/translations/de.json';
import componentHierarchiesFr from 'componentHierarchies/translations/fr.json';
import componentOverviewCustomizationDe from 'admin/componentOverviewCustomization/translations/de.json';
import componentOverviewCustomizationFr from 'admin/componentOverviewCustomization/translations/fr.json';
import orgAdminsListDe from 'admin/orgAdminsList/translations/de.json';
import orgAdminsListFr from 'admin/orgAdminsList/translations/fr.json';
import reportDe from 'report/translations/de.json';
import reportFr from 'report/translations/fr.json';
import integrationsCommonDe from 'integrations/common/translations/de.json';
import integrationsCommonFr from 'integrations/common/translations/fr.json';
import cloudProvidersDe from 'integrations/cloudProviders/translations/de.json';
import cloudProvidersFr from 'integrations/cloudProviders/translations/fr.json';
import itPediaDe from 'integrations/ITPedia/translations/de.json';
import itPediaFr from 'integrations/ITPedia/translations/fr.json';
import lucidchartDe from 'integrations/lucidchart/translations/de.json';
import lucidchartFr from 'integrations/lucidchart/translations/fr.json';
import plantUmlDe from 'graphExport/plantUml/translations/de.json';
import plantUmlFr from 'graphExport/plantUml/translations/fr.json';
import excelV3De from 'integrations/excel-v3/translations/de.json';
import excelV3Fr from 'integrations/excel-v3/translations/fr.json';
import signavioExporterDe from 'integrations/signavio-exporter/translations/de.json';
import signavioExporterFr from 'integrations/signavio-exporter/translations/fr.json';
import celonisExporterDe from 'integrations/celonis-exporter/translations/de.json';
import celonisExporterFr from 'integrations/celonis-exporter/translations/fr.json';
import unifiedIntegrationDe from 'integrations/unified/translations/de.json';
import unifiedIntegrationFr from 'integrations/unified/translations/fr.json';
import azureDe from 'integrations/azure/translations/de.json';
import azureFr from 'integrations/azure/translations/fr.json';
import awsDe from 'integrations/aws/translations/de.json';
import awsFr from 'integrations/aws/translations/fr.json';
import serviceNowDe from 'integrations/service-now/translations/de.json';
import serviceNowFr from 'integrations/service-now/translations/fr.json';
import serviceNowGuidedExporterDe from 'integrations/servicenow-guided-exporter/translations/de.json';
import serviceNowGuidedExporterFr from 'integrations/servicenow-guided-exporter/translations/fr.json';
import microsoftEntraIdDe from 'integrations/entra-id/translations/de.json';
import microsoftEntraIdFr from 'integrations/entra-id/translations/fr.json';
import termsDe from 'admin/terms/translations/de.json';
import termsFr from 'admin/terms/translations/fr.json';
import viewpointsDe from 'viewpoints/translations/de.json';
import viewpointsFr from 'viewpoints/translations/fr.json';
import workspaceManagerDe from 'workspaceManager/translations/de.json';
import workspaceManagerFr from 'workspaceManager/translations/fr.json';
import workspaceModelBrowserDe from 'components/WorkspaceModelBrowser/translations/de.json';
import workspaceModelBrowserFr from 'components/WorkspaceModelBrowser/translations/fr.json';
import appLayoutDe from 'appLayout/translations/de.json';
import appLayoutFr from 'appLayout/translations/fr.json';
import appMainSidebarDe from 'components/AppMainSidebar/translations/de.json';
import appMainSidebarFr from 'components/AppMainSidebar/translations/fr.json';
import canvasDe from 'canvas/translations/de.json';
import canvasFr from 'canvas/translations/fr.json';
import scopeDe from 'scope/translations/de.json';
import scopeFr from 'scope/translations/fr.json';
import scopeDataDe from 'scopeData/translations/de.json';
import scopeDataFr from 'scopeData/translations/fr.json';
import appContainerDe from 'appContainer/translations/de.json';
import appContainerFr from 'appContainer/translations/fr.json';
import architectureModelDe from 'architectureModel/translations/de.json';
import architectureModelFr from 'architectureModel/translations/fr.json';
import workspaceWizardDe from 'workspaceWizard/translations/de.json';
import workspaceWizardFr from 'workspaceWizard/translations/fr.json';
import tableViewsDe from 'tabview/tableViews/translations/de.json';
import tableViewsFr from 'tabview/tableViews/translations/fr.json';
import tabviewDe from 'tabview/translations/de.json';
import tabviewFr from 'tabview/translations/fr.json';
import viewpointBuilderDe from 'viewpointBuilder/translations/de.json';
import viewpointBuilderFr from 'viewpointBuilder/translations/fr.json';
import searchDe from 'search/translations/de.json';
import searchFr from 'search/translations/fr.json';
import componentOverviewDe from 'componentOverview2025/translations/de.json';
import componentOverviewFr from 'componentOverview2025/translations/fr.json';
import restoreDeletedDe from 'restoreDeleted/translations/de.json';
import restoreDeletedFr from 'restoreDeleted/translations/fr.json';
import reverseReferencesDe from 'components/Dialogs/reverseReferences/translations/de.json';
import reverseReferencesFr from 'components/Dialogs/reverseReferences/translations/fr.json';
import surveyModalDe from 'components/SurveyModal/translations/de.json';
import surveyModalFr from 'components/SurveyModal/translations/fr.json';
import transformationsDe from 'transformations/translations/de.json';
import transformationsFr from 'transformations/translations/fr.json';
import traversalPreviewDe from 'components/TraversalPreview/translations/de.json';
import traversalPreviewFr from 'components/TraversalPreview/translations/fr.json';
import traversalsDe from 'traversals/translations/de.json';
import traversalsFr from 'traversals/translations/fr.json';
import viewpointNavigatorDe from 'viewpointNavigator/translations/de.json';
import viewpointNavigatorFr from 'viewpointNavigator/translations/fr.json';
import homePageDe from 'homePage/translations/de.json';
import homePageFr from 'homePage/translations/fr.json';
import foundationHomeDe from 'foundationHome/translations/de.json';
import foundationHomeFr from 'foundationHome/translations/fr.json';
import quickPerspectivesDe from 'quickPerspectives/translations/de.json';
import quickPerspectivesFr from 'quickPerspectives/translations/fr.json';
import perspectiveSidebarDe from 'perspectiveSidebar/translations/de.json';
import perspectiveSidebarFr from 'perspectiveSidebar/translations/fr.json';
import viewDeprecationDe from 'viewDeprecation/translations/de.json';
import viewDeprecationFr from 'viewDeprecation/translations/fr.json';
import fieldDetailsDe from 'fieldDetails/translations/de.json';
import fieldDetailsFr from 'fieldDetails/translations/fr.json';
import fieldTypesDe from 'locales/de/fieldTypes.json';
import fieldTypesFr from 'locales/fr/fieldTypes.json';
import inventoryAppDe from 'inventory/translations/de.json';
import inventoryAppFr from 'inventory/translations/fr.json';
import solutionsDe from 'solutions/translations/de.json';
import solutionsFr from 'solutions/translations/fr.json';
import applicationCompletenessDe from 'applicationCompleteness/translations/de.json';
import applicationCompletenessFr from 'applicationCompleteness/translations/fr.json';
import createComponentDialogDe from 'createComponentDialog/translations/de.json';
import createComponentDialogFr from 'createComponentDialog/translations/fr.json';
import selectParentDialogDe from 'selectParentDialog/translations/de.json';
import selectParentDialogFr from 'selectParentDialog/translations/fr.json';
import selectWorkspaceDialogDe from 'components/selectWorkspaceDialog/translations/de.json';
import selectWorkspaceDialogFr from 'components/selectWorkspaceDialog/translations/fr.json';
import menusDe from 'menus/translations/de.json';
import menusFr from 'menus/translations/fr.json';
import contextMenusDe from 'contextMenus/translations/de.json';
import dynamicReferenceCreationDe from 'dynamicReferenceCreation/translations/de.json';
import contextMenusFr from 'contextMenus/translations/fr.json';
import dynamicReferenceCreationFr from 'dynamicReferenceCreation/translations/fr.json';
import coreDe from 'core/translations/de.json';
import coreFr from 'core/translations/fr.json';
import copyComponentDe from 'copyComponent/translations/de.json';
import copyComponentFr from 'copyComponent/translations/fr.json';
import copyWsDe from 'copyWs/translations/de.json';
import copyWsFr from 'copyWs/translations/fr.json';
import copyWsToOrgDe from 'copyWsToOrg/translations/de.json';
import copyWsToOrgFr from 'copyWsToOrg/translations/fr.json';
import perspectiveDe from 'perspective/translations/de.json';
import perspectiveFr from 'perspective/translations/fr.json';
import assistantDe from 'assistant/translations/de.json';
import assistantFr from 'assistant/translations/fr.json';
import customAgentsDe from 'customAgents/translations/de.json';
import customAgentsFr from 'customAgents/translations/fr.json';
import atomicComponentsDe from 'locales/de/atomicComponents.json';
import atomicComponentsFr from 'locales/fr/atomicComponents.json';
import priorityFieldsDe from 'priorityFields/translations/de.json';
import priorityFieldsFr from 'priorityFields/translations/fr.json';
import consentManagementDe from 'consentManagement/translations/de.json';
import consentManagementFr from 'consentManagement/translations/fr.json';
import editorsDe from 'editors/template/translations/de.json';
import editorsFr from 'editors/template/translations/fr.json';
import assetLibraryDe from 'assetLibrary/translations/de.json';
import assetLibraryFr from 'assetLibrary/translations/fr.json';
import quickLinksDe from 'quickLinks/translations/de.json';
import quickLinksFr from 'quickLinks/translations/fr.json';
import addChildDialogDe from 'addChildDialog/translations/de.json';
import addChildDialogFr from 'addChildDialog/translations/fr.json';
import documentArchiveDe from 'documentArchive/translations/de.json';
import documentArchiveFr from 'documentArchive/translations/fr.json';
import authDe from 'auth/translations/de.json';
import authFr from 'auth/translations/fr.json';
import createOrgDe from 'createOrg/translations/de.json';
import createOrgFr from 'createOrg/translations/fr.json';
import missingOrgDe from 'missingOrg/translations/de.json';
import missingOrgFr from 'missingOrg/translations/fr.json';
import ipAddressBlockedDe from 'ipAddressBlocked/translations/de.json';
import ipAddressBlockedFr from 'ipAddressBlocked/translations/fr.json';
import navigator2024De from 'navigator2024/translations/de.json';
import navigator2024Fr from 'navigator2024/translations/fr.json';
import viewsDe from 'views/translations/de.json';
import viewsFr from 'views/translations/fr.json';
import syncDe from 'sync/translations/de.json';
import syncFr from 'sync/translations/fr.json';
import resourcePermissionsDe from 'resourcePermissions/translations/de.json';
import resourcePermissionsFr from 'resourcePermissions/translations/fr.json';
import ephemeralNotificationDe from 'ephemeralNotification/translations/de.json';
import ephemeralNotificationFr from 'ephemeralNotification/translations/fr.json';
import tableFilterBarDe from 'tableFilterBar/translations/de.json';
import tableFilterBarFr from 'tableFilterBar/translations/fr.json';
import viewModeDe from 'locales/de/viewMode.json';
import viewModeFr from 'locales/fr/viewMode.json';
import loaderDe from 'loader/translations/de.json';
import loaderFr from 'loader/translations/fr.json';
import errorBoundaryDe from 'errorBoundary/translations/de.json';
import errorBoundaryFr from 'errorBoundary/translations/fr.json';
import externalDocumentsDe from 'externalDocuments/translations/de.json';
import externalDocumentsFr from 'externalDocuments/translations/fr.json';
import externallyManagedDe from 'externallyManaged/translations/de.json';
import externallyManagedFr from 'externallyManaged/translations/fr.json';

/**
 * Locale resource bundles for all supported non-English languages.
 * Keyed by BCP 47 language tag (e.g. 'de').
 *
 * Both initI18n (initial load) and i18nLocale$ (reactive sync)
 * consume this map, so adding a new language requires only one change here.
 */
export const LOCALE_BUNDLES: Record<string, I18nLocale> = {
  de: {
    dateRange: dateRangeTranslationsDe,
    dateTime: dateTimeTranslationsDe,
    dateTimePicker: dateTimePickerTranslationsDe,
    button: buttonTranslationsDe,
    card: cardTranslationsDe,
    drawer: drawerTranslationsDe,
    dropdownMenu: dropdownMenuTranslationsDe,
    steppers: steppersTranslationsDe,
    pageLayout: pageLayoutTranslationsDe,
    productTours: productToursTranslationsDe,
    forms: formsTranslationsDe,
    impersonation: impersonationTranslationsDe,
    common: commonDe,
    commonHelpers: commonHelpersTranslationsDe,
    colorPicker: colorPickerDe,
    landingPage: landingPageDe,
    pagination: paginationDe,
    referenceData: referenceDataDe,
    flexibleBlockDiagram: flexibleBlockDiagramDe,
    relationsD3View: relationsD3ViewDe,
    renderers: renderersTranslationsDe,
    reportBuilder: reportBuilderDe,
    reportReader: reportReaderDe,
    select: selectTranslationsDe,
    settingsBar: settingsBarTranslationsDe,
    simpleBlockDiagram: simpleBlockDiagramDe,
    statusUi: statusUiTranslationsDe,
    surveysUi: surveysUiTranslationsDe,
    snowflakes: snowflakesTranslationsDe,
    dropzone: dropzoneDe,
    modal: modalDe,
    inAppNotifications: {
      ...inAppNotificationsPackageDe,
      ...inAppNotificationsDe,
    },
    imagePreview: imagePreviewDe,
    errorInfoBox: errorInfoBoxDe,
    table: tableDe,
    tags: tagsDe,
    navigationTopBar: navigationTopBarDe,
    bubbleChart: bubbleChartDe,
    bundles: bundlesDe,
    customAgents: customAgentsDe,
    cardGridViewer: cardGridViewerDe,
    profile: profileDe,
    account: accountDe,
    orgSettings: orgSettingsDe,
    brandingSettings: brandingSettingsDe,
    featureSettings: featureSettingsDe,
    homeSettings: homeSettingsDe,
    aiSettings: aiSettingsDe,
    ardoqCatalog: ardoqCatalogDe,
    catalogFeedback: catalogFeedbackDe,
    catalogAttribution: catalogAttributionDe,
    catalogDetails: catalogDetailsDe,
    catalogLink: catalogLinkDe,
    catalogSearch: catalogSearchDe,
    catalogPendingLinks: catalogPendingLinksDe,
    transformationsSettings: transformationsSettingsDe,
    catalogFieldMapping: catalogFieldMappingDe,
    graph: graphTranslationsDe,
    graphView: graphViewTranslationsDe,
    graphFilters: graphFiltersDe,
    manageOrganization: manageOrganizationDe,
    manageResourcePermissions: manageResourcePermissionsDe,
    subscription: subscriptionDe,
    timeTravel: timeTravelDe,
    workspaceOverview: workspaceOverviewDe,
    migrationChecklist: migrationChecklistDe,
    systemOverview: systemOverviewDe,
    entityBrowser: entityBrowserDe,
    entityGroup: entityGroupDe,
    entityMerge: entityMergeDe,
    surveyAdmin: surveyAdminDe,
    surveyModal: surveyModalDe,
    dashboard: { ...dashboardPackageDe, ...dashboardDe },
    discoverLandingPage: discoverLandingPageDe,
    discoverSettings: discoverSettingsDe,
    serviceAccounts: serviceAccountsDe,
    ipAllowListing: ipAllowListingDe,
    orgMembers: orgMembersDe,
    privileges: privilegesDe,
    permissionGroups: permissionGroupsDe,
    permissionsPanel: permissionsPanelDe,
    ssoAttributeMapping: ssoAttributeMappingDe,
    assetsOverview: assetsOverviewDe,
    auditLog: auditLogDe,
    presentationAdmin: presentationAdminDe,
    presentationEditor: presentationEditorDe,
    presentationSidebar: presentationSidebarDe,
    presentationsBrowser: presentationsBrowserDe,
    propertiesEditor: propertiesEditorDe,
    assetsBrowser: assetsBrowserDe,
    metamodel: metamodelDe,
    metamodelConstraints: metamodelConstraintsDe,
    metamodelEditor: metamodelEditorDe,
    metamodelVisualization: metamodelVisualizationDe,
    organizationMetamodel: organizationMetamodelDe,
    broadcasts: broadcastsDe,
    globalLogin: globalLoginDe,
    gridEditor: gridEditorDe,
    searchModal: searchModalDe,
    tasks: tasksDe,
    contextBar: contextBarDe,
    dataLimit: dataLimitDe,
    defaultFields: defaultFieldsDe,
    confirmDeletion: confirmDeletionDe,
    deleteAssetModal: deleteAssetModalDe,
    diffMerge: diffMergeDe,
    emptyWorkspace: emptyWorkspaceDe,
    login: loginPackageDe,
    loginSettings: loginSettingsDe,
    userProvisioningSettings: userProvisioningSettingsDe,
    manageUserRoles: manageUserRolesDe,
    helpAndSupport: helpAndSupportDe,
    accessControl: accessControlPackageDe,
    accessControlContainer: accessControlContainerDe,
    ai: aiTranslationsDe,
    roles: rolesDe,
    componentHierarchies: {
      ...componentHierarchiesPackageDe,
      ...componentHierarchiesDe,
    },
    componentOverviewCustomization: componentOverviewCustomizationDe,
    orgAdminsList: orgAdminsListDe,
    confidentialFields: confidentialFieldsDe,
    useCase: useCaseDe,
    useCases: useCasesDe,
    report: reportDe,
    integrations: { ...integrationsPackageDe, ...integrationsCommonDe },
    cloudProviders: cloudProvidersDe,
    itPedia: itPediaDe,
    jsonIntegration: jsonIntegrationDe,
    lucidchart: lucidchartDe,
    plantUml: plantUmlDe,
    excelV3: excelV3De,
    signavioExporter: signavioExporterDe,
    celonisExporter: celonisExporterDe,
    unifiedIntegration: unifiedIntegrationDe,
    azure: azureDe,
    aws: awsDe,
    serviceNow: serviceNowDe,
    serviceNowGuidedExporter: serviceNowGuidedExporterDe,
    microsoftEntraId: microsoftEntraIdDe,
    terms: termsDe,
    viewpoints: viewpointsDe,
    workspaceManager: workspaceManagerDe,
    workspaceModelBrowser: workspaceModelBrowserDe,
    canvas: canvasDe,
    scope: scopeDe,
    scopeData: scopeDataDe,
    appContainer: appContainerDe,
    appLayout: appLayoutDe,
    appMainSidebar: appMainSidebarDe,
    architectureModel: architectureModelDe,
    workspaceWizard: workspaceWizardDe,
    tableViews: tableViewsDe,
    tabview: tabviewDe,
    timeline: timelineDe,
    timeline2024: timeline2024TranslationsDe,
    viewpointBuilder: viewpointBuilderDe,
    search: searchDe,
    componentOverview: {
      ...componentOverviewPackageDe,
      ...componentOverviewDe,
    },
    restoreDeleted: restoreDeletedDe,
    reverseReferences: reverseReferencesDe,
    transformations: transformationsDe,
    traversalPreview: traversalPreviewDe,
    traversals: traversalsDe,
    viewpointNavigator: viewpointNavigatorDe,
    homePage: homePageDe,
    foundationHome: foundationHomeDe,
    queryBuilder: queryBuilderTranslationsDe,
    quickPerspectives: quickPerspectivesDe,
    perspectiveSidebar: perspectiveSidebarDe,
    perspectives: perspectivesTranslationsDe,
    perspectivesSidebar: perspectivesSidebarTranslationsDe,
    viewDeprecation: viewDeprecationDe,
    fieldDetails: fieldDetailsDe,
    fieldTypes: fieldTypesDe,
    folderSelectDialog: folderSelectDialogDe,
    locationSelect: locationSelectDe,
    inventory: inventoryTranslationsDe,
    provenance: provenanceTranslationsDe,
    inventoryApp: inventoryAppDe,
    solutions: solutionsDe,
    applicationCompleteness: applicationCompletenessDe,
    createComponentDialog: createComponentDialogDe,
    selectParentDialog: selectParentDialogDe,
    selectWorkspaceDialog: selectWorkspaceDialogDe,
    menus: menusDe,
    contextMenus: contextMenusDe,
    dynamicReferenceCreation: dynamicReferenceCreationDe,
    core: coreDe,
    copyComponent: copyComponentDe,
    copyWs: copyWsDe,
    copyWsToOrg: copyWsToOrgDe,
    perspective: perspectiveDe,
    assistant: assistantDe,
    atomicComponents: atomicComponentsDe,
    priorityFields: priorityFieldsDe,
    consentManagement: consentManagementDe,
    editors: editorsDe,
    assetLibrary: assetLibraryDe,
    quickLinks: quickLinksDe,
    addChildDialog: addChildDialogDe,
    documentArchive: documentArchiveDe,
    auth: authDe,
    createOrg: createOrgDe,
    missingOrg: missingOrgDe,
    ipAddressBlocked: ipAddressBlockedDe,
    navigator2024: navigator2024De,
    notFound: notFoundDe,
    views: viewsDe,
    sync: syncDe,
    resourcePermissions: resourcePermissionsDe,
    ephemeralNotification: ephemeralNotificationDe,
    richTextEditor: richTextEditorTranslationsDe,
    tableFilterBar: tableFilterBarDe,
    viewLegend: viewLegendDe,
    viewMode: viewModeDe,
    loader: loaderDe,
    errorBoundary: errorBoundaryDe,
    apiErrors: apiErrorsDe,
    externalDocuments: externalDocumentsDe,
    externallyManaged: externallyManagedDe,
  },
  fr: {
    dateRange: dateRangeTranslationsFr,
    dateTime: dateTimeTranslationsFr,
    dateTimePicker: dateTimePickerTranslationsFr,
    button: buttonTranslationsFr,
    card: cardTranslationsFr,
    drawer: drawerTranslationsFr,
    dropdownMenu: dropdownMenuTranslationsFr,
    steppers: steppersTranslationsFr,
    pageLayout: pageLayoutTranslationsFr,
    productTours: productToursTranslationsFr,
    forms: formsTranslationsFr,
    impersonation: impersonationTranslationsFr,
    common: commonFr,
    commonHelpers: commonHelpersTranslationsFr,
    colorPicker: colorPickerFr,
    landingPage: landingPageFr,
    pagination: paginationFr,
    referenceData: referenceDataFr,
    flexibleBlockDiagram: flexibleBlockDiagramFr,
    relationsD3View: relationsD3ViewFr,
    renderers: renderersTranslationsFr,
    reportBuilder: reportBuilderFr,
    reportReader: reportReaderFr,
    select: selectTranslationsFr,
    settingsBar: settingsBarTranslationsFr,
    simpleBlockDiagram: simpleBlockDiagramFr,
    statusUi: statusUiTranslationsFr,
    surveysUi: surveysUiTranslationsFr,
    snowflakes: snowflakesTranslationsFr,
    dropzone: dropzoneFr,
    modal: modalFr,
    inAppNotifications: {
      ...inAppNotificationsPackageFr,
      ...inAppNotificationsFr,
    },
    imagePreview: imagePreviewFr,
    errorInfoBox: errorInfoBoxFr,
    table: tableFr,
    tags: tagsFr,
    navigationTopBar: navigationTopBarFr,
    bubbleChart: bubbleChartFr,
    bundles: bundlesFr,
    customAgents: customAgentsFr,
    cardGridViewer: cardGridViewerFr,
    profile: profileFr,
    account: accountFr,
    orgSettings: orgSettingsFr,
    brandingSettings: brandingSettingsFr,
    featureSettings: featureSettingsFr,
    homeSettings: homeSettingsFr,
    aiSettings: aiSettingsFr,
    ardoqCatalog: ardoqCatalogFr,
    catalogFeedback: catalogFeedbackFr,
    catalogAttribution: catalogAttributionFr,
    catalogDetails: catalogDetailsFr,
    catalogLink: catalogLinkFr,
    catalogSearch: catalogSearchFr,
    catalogPendingLinks: catalogPendingLinksFr,
    transformationsSettings: transformationsSettingsFr,
    catalogFieldMapping: catalogFieldMappingFr,
    graph: graphTranslationsFr,
    graphView: graphViewTranslationsFr,
    graphFilters: graphFiltersFr,
    manageOrganization: manageOrganizationFr,
    manageResourcePermissions: manageResourcePermissionsFr,
    subscription: subscriptionFr,
    timeTravel: timeTravelFr,
    workspaceOverview: workspaceOverviewFr,
    migrationChecklist: migrationChecklistFr,
    systemOverview: systemOverviewFr,
    entityBrowser: entityBrowserFr,
    entityGroup: entityGroupFr,
    entityMerge: entityMergeFr,
    surveyAdmin: surveyAdminFr,
    surveyModal: surveyModalFr,
    dashboard: { ...dashboardPackageFr, ...dashboardFr },
    discoverLandingPage: discoverLandingPageFr,
    discoverSettings: discoverSettingsFr,
    serviceAccounts: serviceAccountsFr,
    ipAllowListing: ipAllowListingFr,
    orgMembers: orgMembersFr,
    privileges: privilegesFr,
    permissionGroups: permissionGroupsFr,
    permissionsPanel: permissionsPanelFr,
    ssoAttributeMapping: ssoAttributeMappingFr,
    assetsOverview: assetsOverviewFr,
    auditLog: auditLogFr,
    presentationAdmin: presentationAdminFr,
    presentationEditor: presentationEditorFr,
    presentationSidebar: presentationSidebarFr,
    presentationsBrowser: presentationsBrowserFr,
    propertiesEditor: propertiesEditorFr,
    assetsBrowser: assetsBrowserFr,
    metamodel: metamodelFr,
    metamodelConstraints: metamodelConstraintsFr,
    metamodelEditor: metamodelEditorFr,
    metamodelVisualization: metamodelVisualizationFr,
    organizationMetamodel: organizationMetamodelFr,
    broadcasts: broadcastsFr,
    globalLogin: globalLoginFr,
    gridEditor: gridEditorFr,
    searchModal: searchModalFr,
    tasks: tasksFr,
    contextBar: contextBarFr,
    dataLimit: dataLimitFr,
    defaultFields: defaultFieldsFr,
    confirmDeletion: confirmDeletionFr,
    deleteAssetModal: deleteAssetModalFr,
    diffMerge: diffMergeFr,
    emptyWorkspace: emptyWorkspaceFr,
    login: loginPackageFr,
    loginSettings: loginSettingsFr,
    userProvisioningSettings: userProvisioningSettingsFr,
    manageUserRoles: manageUserRolesFr,
    helpAndSupport: helpAndSupportFr,
    accessControl: accessControlPackageFr,
    accessControlContainer: accessControlContainerFr,
    ai: aiTranslationsFr,
    roles: rolesFr,
    componentHierarchies: {
      ...componentHierarchiesPackageFr,
      ...componentHierarchiesFr,
    },
    componentOverviewCustomization: componentOverviewCustomizationFr,
    orgAdminsList: orgAdminsListFr,
    confidentialFields: confidentialFieldsFr,
    useCase: useCaseFr,
    useCases: useCasesFr,
    report: reportFr,
    integrations: { ...integrationsPackageFr, ...integrationsCommonFr },
    cloudProviders: cloudProvidersFr,
    itPedia: itPediaFr,
    jsonIntegration: jsonIntegrationFr,
    lucidchart: lucidchartFr,
    plantUml: plantUmlFr,
    excelV3: excelV3Fr,
    signavioExporter: signavioExporterFr,
    celonisExporter: celonisExporterFr,
    unifiedIntegration: unifiedIntegrationFr,
    azure: azureFr,
    aws: awsFr,
    serviceNow: serviceNowFr,
    serviceNowGuidedExporter: serviceNowGuidedExporterFr,
    microsoftEntraId: microsoftEntraIdFr,
    terms: termsFr,
    viewpoints: viewpointsFr,
    workspaceManager: workspaceManagerFr,
    workspaceModelBrowser: workspaceModelBrowserFr,
    canvas: canvasFr,
    scope: scopeFr,
    scopeData: scopeDataFr,
    appContainer: appContainerFr,
    appLayout: appLayoutFr,
    appMainSidebar: appMainSidebarFr,
    architectureModel: architectureModelFr,
    workspaceWizard: workspaceWizardFr,
    tableViews: tableViewsFr,
    tabview: tabviewFr,
    timeline: timelineFr,
    timeline2024: timeline2024TranslationsFr,
    viewpointBuilder: viewpointBuilderFr,
    search: searchFr,
    componentOverview: {
      ...componentOverviewPackageFr,
      ...componentOverviewFr,
    },
    restoreDeleted: restoreDeletedFr,
    reverseReferences: reverseReferencesFr,
    transformations: transformationsFr,
    traversalPreview: traversalPreviewFr,
    traversals: traversalsFr,
    viewpointNavigator: viewpointNavigatorFr,
    homePage: homePageFr,
    foundationHome: foundationHomeFr,
    queryBuilder: queryBuilderTranslationsFr,
    quickPerspectives: quickPerspectivesFr,
    perspectiveSidebar: perspectiveSidebarFr,
    perspectives: perspectivesTranslationsFr,
    perspectivesSidebar: perspectivesSidebarTranslationsFr,
    viewDeprecation: viewDeprecationFr,
    fieldDetails: fieldDetailsFr,
    fieldTypes: fieldTypesFr,
    folderSelectDialog: folderSelectDialogFr,
    locationSelect: locationSelectFr,
    inventory: inventoryTranslationsFr,
    provenance: provenanceTranslationsFr,
    inventoryApp: inventoryAppFr,
    solutions: solutionsFr,
    applicationCompleteness: applicationCompletenessFr,
    createComponentDialog: createComponentDialogFr,
    selectParentDialog: selectParentDialogFr,
    selectWorkspaceDialog: selectWorkspaceDialogFr,
    menus: menusFr,
    contextMenus: contextMenusFr,
    dynamicReferenceCreation: dynamicReferenceCreationFr,
    core: coreFr,
    copyComponent: copyComponentFr,
    copyWs: copyWsFr,
    copyWsToOrg: copyWsToOrgFr,
    perspective: perspectiveFr,
    assistant: assistantFr,
    atomicComponents: atomicComponentsFr,
    priorityFields: priorityFieldsFr,
    consentManagement: consentManagementFr,
    editors: editorsFr,
    assetLibrary: assetLibraryFr,
    quickLinks: quickLinksFr,
    addChildDialog: addChildDialogFr,
    documentArchive: documentArchiveFr,
    auth: authFr,
    createOrg: createOrgFr,
    missingOrg: missingOrgFr,
    ipAddressBlocked: ipAddressBlockedFr,
    navigator2024: navigator2024Fr,
    notFound: notFoundFr,
    views: viewsFr,
    sync: syncFr,
    resourcePermissions: resourcePermissionsFr,
    ephemeralNotification: ephemeralNotificationFr,
    richTextEditor: richTextEditorTranslationsFr,
    tableFilterBar: tableFilterBarFr,
    viewLegend: viewLegendFr,
    viewMode: viewModeFr,
    loader: loaderFr,
    errorBoundary: errorBoundaryFr,
    apiErrors: apiErrorsFr,
    externalDocuments: externalDocumentsFr,
    externallyManaged: externallyManagedFr,
  },
};

export const DEFAULT_I18N_CONFIG = {
  lng: 'en' as const,
  resources: LOCALE_BUNDLES,
};
